/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Log_Into_Your_Domain_RegistrarInputs */

const en_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log into your domain registrar (GoDaddy, etc.) and add these exact records to your DNS settings. Then click Verify below.`)
};

const es_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en tu registrador de dominios (GoDaddy, etc.) y agrega estos registros exactos a tu configuración de DNS. Luego haz clic en Verificar a continuación.`)
};

const fr_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous à votre registraire de domaine (GoDaddy, etc.) et ajoutez ces enregistrements exacts à vos paramètres DNS. Cliquez ensuite sur Vérifier ci-dessous.`)
};

const de_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich bei deinem Domain-Registrar an (GoDaddy, etc.) und füge diese genauen Einträge zu deinen DNS-Einstellungen hinzu. Klicke dann unten auf Überprüfen.`)
};

const ja_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメインレジストラ (GoDaddyなど) にログインし、DNS設定にこれらの正確なレコードを追加します。その後、下の「検証」をクリックしてください。`)
};

const zh_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录您的域名注册商 (GoDaddy 等)，并将这些准确的记录添加到您的 DNS 设置中。然后点击下方的验证。`)
};

const ar_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتسجيل الدخول إلى مسجل النطاق الخاص بك (GoDaddy، إلخ) وأضف هذه السجلات الدقيقة إلى إعدادات DNS الخاصة بك. ثم انقر على تحقق أدناه.`)
};

const id_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke registrar domain Anda (GoDaddy, dll.) dan tambahkan data persis ini ke pengaturan DNS Anda. Kemudian klik Verifikasi di bawah.`)
};

const it_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi al tuo registrar di domini (GoDaddy, ecc.) e aggiungi questi record esatti alle tue impostazioni DNS. Quindi clicca su Verifica in basso.`)
};

const ru_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите к своему регистратору доменов (GoDaddy и т.д.) и добавьте эти точные записи в настройки DNS. Затем нажмите 'Проверить' ниже.`)
};

const pt_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça login no seu registrador de domínio (GoDaddy, etc.) e adicione estes registros exatos às suas configurações de DNS. Em seguida, clique em Verificar abaixo.`)
};

const ko_log_into_your_domain_registrar = /** @type {(inputs: Log_Into_Your_Domain_RegistrarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도메인 등록업체(GoDaddy 등)에 로그인하여 이 정확한 레코드를 DNS 설정에 추가하세요. 그런 다음 아래의 검증을 클릭하세요.`)
};

/**
* | output |
* | --- |
* | "Log into your domain registrar (GoDaddy, etc.) and add these exact records to your DNS settings. Then click Verify below." |
*
* @param {Log_Into_Your_Domain_RegistrarInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const log_into_your_domain_registrar = /** @type {((inputs?: Log_Into_Your_Domain_RegistrarInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Log_Into_Your_Domain_RegistrarInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_log_into_your_domain_registrar(inputs)
	if (locale === "es") return es_log_into_your_domain_registrar(inputs)
	if (locale === "fr") return fr_log_into_your_domain_registrar(inputs)
	if (locale === "de") return de_log_into_your_domain_registrar(inputs)
	if (locale === "ja") return ja_log_into_your_domain_registrar(inputs)
	if (locale === "zh") return zh_log_into_your_domain_registrar(inputs)
	if (locale === "ar") return ar_log_into_your_domain_registrar(inputs)
	if (locale === "id") return id_log_into_your_domain_registrar(inputs)
	if (locale === "it") return it_log_into_your_domain_registrar(inputs)
	if (locale === "ru") return ru_log_into_your_domain_registrar(inputs)
	if (locale === "pt") return pt_log_into_your_domain_registrar(inputs)
	return ko_log_into_your_domain_registrar(inputs)
});